    <template>
            <div class="">                        
                <h1 class="text-muted mb-4">
                        <vue-fontawesome class="mr-2" icon="sort"></vue-fontawesome>          
                        <router-link class="ml-2 text-decoration-none"
                            :to="{ name: `stock`, query: { destroy : destroy }}">
                            <i class="ml-2 arrow left" style="height:25px;width:25px"></i>
                            Stock
                        </router-link>   
                        / count stock
                    </h1>          
                <div>
                    <div class="d-flex justify-content-between">
                        <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                                <li class="nav-item">
                                    <a class="nav-link active" 
                                        id="pills-home-tab" 
                                        data-toggle="pill" 
                                        href="#pills-home" 
                                        role="tab" 
                                        aria-controls="pills-home" 
                                        aria-selected="true">
                                                                
                                        Incoplete
                                    </a>
                                </li>                       							
                        </ul>                
                    </div>									
                    <div class="tab-content" id="pills-tabContent">
                        <div class="tab-pane fade show active" 
                            id="pills-home" 
                            role="tabpanel" 
                            aria-labelledby="pills-home-tab">
                            <div class="mb-4 d-flex justify-content-between p-2 border border-light shadow-sm rounded">
                                <!-- right -->
                                <section class="d-flex">                                
                                    <div class="dropdown">
                                        <a class="btn btn-light dropdown-toggle" 
                                            href="#" role="button" id="dropdownMenuLink" 
                                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            Filters
                                        </a>
                                        
                                        <div class="dropdown-menu border-0 shadow p-3" aria-labelledby="dropdownMenuLink" style="min-width: 25vw">
                                                <div class="form-group d-flex justify-content-between">
                                                    <label class="p-2">Search</label>
                                                    <input type="text" class="col-8 form-control" v-model="search"> 
                                                </div>                                                                               	
                                        </div>
                                    </div>                             
                                    <div class="ml-2 d-flex justify-content">            
                                        <vue-fontawesome class="mr-1 ml-3 mt-2" icon="map-marker"></vue-fontawesome>                      
                                        <select class="col-8 p-0 form-control" style="width: 300px;" v-model="location">                                        
                                            <option v-for="(location,index) in locations" :key="index" :value="location">                                            
                                                {{location.name}}
                                            </option>
                                        </select>                                                                                                               
                                    </div>                                                               	
                                </section>  
                                <!-- add buttons --> 
                                <div>
                                    <button class="btn btn-success"
                                        @click="markAllAsNotCounted()">
                                        Clear
                                    </button>  
                                </div>               																							
                            </div>    
                            <!-- STOCK TAKE TABLE AND DEPENDENCIES -->
                            <div class="rounded shadow border border-light p-2">
                                <table class="table table-borderless table-responsive-sm paginate" 
                                    id="productsTable"
                                    data-pagecount="3">
                                    <thead >
                                        <tr>	
                                            <th></th>	                                                                
                                            <th scope="col">                                       
                                                Name
                                            </th>
                                            <th scope="col">sku</th>
                                            <th scope="col">                                        
                                                Retail price
                                            </th>	
                                            <th scope="col">                                       
                                                Wholesale price
                                            </th>	                                   	
                                            <th scope="col">                                       
                                                Min required
                                            </th>	
                                            <th scope="col">                                        
                                                Stock
                                            </th>	                                				
                                            <th scope="col"></th>	
                                        </tr>
                                    </thead>
                                    <tbody v-if="products && products.length">
                                        <!-- initially selected row -->                                            
                                        <tr class="cursor-pointer" v-for="(product,index) in products" :key="index">   
                                            <td class="ml-0">
                                                <span v-if="product.counted" class="ml-5 badge badge-pill badge-success">counted</span>
                                                <span v-else class="ml-5 badge badge-pill badge-danger">not counted</span>
                                            </td>                                 
                                            <td>
                                                <vue-fontawesome v-if="product.variant" class="mr-2 text-muted" 
                                                    icon="copy" data-toggle="tooltip" title="Variant">                                            
                                                </vue-fontawesome>          
                                                {{product.name}}
                                            </td>		
                                            <td>{{product.sku}}</td>                                
                                            <td>{{product.retail_price | intcomma}}</td>																
                                            <td>{{product.wholesale_price | intcomma}}</td>                                    
                                            <td>{{product.minimum_required |intcomma}}</td>
                                            <td>{{product.stock | intcomma}}</td>  
                                            <td>
                                                    <button class="ml-2 btn btn-outline-success" data-toggle="modal" data-target="#editProductModal" 
                                                        @click="selectProduct(product)">
                                                        count
                                                    </button>                                        
                                            </td>                              
                                        </tr>											
                                    </tbody>
                                </table>
                                <div class="p-3 d-flex justify-content-center"
                                    v-if="products && ! products.length">
                                    No records to show
                                </div>
                                <div class="p-3 d-flex justify-content-center"
                                    v-if="! products">
                                    <div class="spinner-border p-3 m-5" role="status">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                </div>    
                            </div>                   
                        </div>                
                    </div> 		  
                </div>	
                <!-- modals -->
                <section>        
                    <!-- edit stock modal -->
                    <div class="modal fade" id="editProductModal" tabindex="-1" role="dialog" aria-labelledby="editProducModal" aria-hidden="true">
                            <div class="modal-dialog modal-dialog-centered" role="document" v-if="product">
                                <div class="modal-content">                                   
                                    <div class="modal-header border-0">                                                                        
                                        <h5 class="modal-title">                                        
                                            <h6 class="text-muted d-flex justify-content-start">
                                                <vue-fontawesome class="mr-2" icon="map-marker"></vue-fontawesome>
                                                {{location.name}}
                                            </h6>
                                            <vue-fontawesome v-if="product.variant" class="mr-2 text-muted" 
                                                icon="copy" data-toggle="tooltip" title="Variant">                                            
                                            </vue-fontawesome>
                                            {{product.name}}
                                            <br>
                                            <small>
                                                current stock :<b> {{product.stock}}</b>                                             
                                            </small>
                                            <br>
                                            <small class="text-muted">{{product_index + 1}} of {{products.length}}</small>
                                            <small v-if="product.counted"><span class="ml-5 badge badge-pill badge-success">counted</span></small>
                                            <small v-else><span class="ml-5 badge badge-pill badge-danger">not counted</span></small>
                                        </h5>                                                               
                                        <button type="button" id="closeEditroductModal" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div> 
                                    <div id="editProductForm">                                
                                        <div class="modal-body d-flex justify-content-center"  style="max-height: 70vh; overflow-y: scroll"> 
                                                <div class="d-flex flex-column justify-content-center text-center"
                                                    @click="product_index -= 1" v-if="product_index > 0">
                                                    <span class="d-flex text-primary cursor-pointer">
                                                        <i class="mt-2 ml-2 arrow left" style="height:10px;width:10px"></i> 
                                                        <span class="">previous</span>
                                                    </span>                                            
                                                </div> 
                                            <div class="d-flex flex-column justify-content-center">
                                                <div class="text-center"  @click="product_to_adjust.new_stock += 1">                                
                                                    <h2><vue-fontawesome class="cursor-pointer ml-2" icon="sort-asc"></vue-fontawesome>  </h2>
                                                </div>                                                                                                                                                                                                                                 
                                                <div class="p-3 d-flex justify-content-center ">                                        
                                                    <input type="number" class="text-center col-5 form-control border-0 font-weight-bold" 
                                                        style="font-size: 25px" v-model="product_to_adjust.new_stock">
                                                </div>                                                                                                                                                       
                                                <div class="text-center" @click="product_to_adjust.new_stock -= 1">
                                                    <h2><vue-fontawesome class="cursor-pointer ml-2" icon="sort-down"></vue-fontawesome>  </h2>
                                                </div> 
                                            </div>  
                                            <div class="d-flex flex-column justify-content-center text-center"
                                                @click="product_index += 1" v-if="(product_index + 1) !== products.length">
                                                <span class="d-flex text-primary cursor-pointer">                                            
                                                    <span class="">next</span>
                                                    <i class="mt-2 ml-2 arrow right" style="height:10px;width:10px"></i> 
                                                </span>
                                            </div>                                                                     
                                        </div>                                
                                        <div class="modal-footer border-0">                            
                                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                                            <button class="btn btn-success"
                                                @click="countStock()">
                                                Save changes
                                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="updating_stock"></span>
                                            </button>
                                        </div> 
                                    </div>                                                                                                                                                                                                                                     
                                </div>
                            </div>
                    </div>
                </section>
            </div>
        </template>
        <script>
        export default {
            name: 'products',
            props: {
                msg: String
            },
            data(){
                return{
                    search:null,
                    products:null,    
                    //selected product
                    product:null, 
                    product_index: null,  
                    locations:null,
                    //selected location
                    location: {}, 
                    //receipt modal.
                    receipt_modal_data:null,            
                    updating_stock:false,
                    product_to_adjust:{
                        id:null,
                        new_stock: 0,                                                           
                    },     
                    //whether to destroy stock component (if an update is made 
                    //here then it has to be destroyed as it would have wrong details)
                    destroy: false           
                }
            },
            mounted(){            
                this.getProducts()  
                this.getLocations()        
            },
            watch:{
                search:function(){			
                    this.$searchTable('productsTable',this.search)			
                },
                product_index: function(){
                    if (this.product_index){
                        if(this.products[this.product_index]){
                            this.selectProduct(this.products[this.product_index])
                        }
                        else{
                            this.product_index = 0
                        }
                    }
                }
            },
            methods:{
                //get sales by user		
                getProducts: function(){	
                    // get from localStorage	
                    if (localStorage.getItem("stock_take_products") !== null) {
                        this.products = JSON.parse(localStorage.getItem("stock_take_products"))                    
                    }
                    //else try network
                    else{
                        this.$http({
                            method:'get',				
                            url: this.$API_BASE_URL + `/HJYBCFRB/${this.$version}/products/`,
                            headers:{			
                                Authorization: JSON.parse(localStorage.getItem('auth_token'))                        
                            }
                        }).then((response)=>{                    
                            this.products = this.expandVariants(response.data)
                            localStorage.setItem('stock_take_products',JSON.stringify(this.products))
                        }).catch((err)=>{                    
                            this.$emit('alert',err)
                        })
                    }
                },	 
                //expand variants
                expandVariants: function(response_data)  {
                    var products = []
                    //expand variants
                    for (var product of response_data){                        
                        if (! product.variants.length){ 
                            product.variant = null
                            //mark as not counted
                            product.counted = false
                            products.push(product)
                        }
                        else{                    
                            var product_name = product.name                                                
                            for (var variant of product.variants){   
                                // Shallow Copy Using the spread operator to avoid updating the global
                                var this_product = {...product}                                                                                                              
                                this_product.name = `${product_name} (${variant.variation_name})`                                
                                this_product.variant = variant.variation_id  
                                this_product.purchase_price = variant.purchase_price
                                this_product.retail_price = variant.retail_price
                                this_product.base_selling_price = variant.base_selling_price                              
                                this_product.stock = variant.stock
                                //mark as not counted
                                product.counted = false
                                products.push(this_product)
                            }                        
                        }
                    }
                    return products
                },
                selectProduct: function(product){
                    this.product = product
                    this.product_to_adjust.new_stock = product.stock
                    this.product_index = this.products.findIndex((p)=>{return p === product})
                },   
                //mark all products as not counted
                markAllAsNotCounted: function(){
                    for (var product of this.products){
                        product.counted = false
                    }
                    localStorage.setItem('stock_take_products',JSON.stringify(this.products))
                },
                //locations types for when adding
                getLocations: function(){                            
                    this.$http({
                        method:'get',				
                        url: this.$API_BASE_URL + `/HJYBCFRB/${this.$version}/locations/`,
                        headers:{
                            Authorization: JSON.parse(localStorage.getItem('auth_token'))
                        },                
                    }).then((response)=>{
                        this.locations = response.data
                        var current_location = JSON.parse(localStorage.getItem('logged_in_user_location_id'))
                        var location = this.locations.filter((l)=>{
                            return l.id === current_location
                        })
                        this.location = location[0]
                    }).catch((err)=>{
                        this.$emit('alert',err)
                    })
                },           
                //edit stock
                countStock: function(){                             
                    this.updating_stock = true
                    var data = {
                            item: this.product.id,
                            variant_id: this.product.variant,
                            location: this.location.id,
                            new_count: this.product_to_adjust.new_stock
                        }             
                    this.$http({
                        method:'post',
                        url: this.$API_BASE_URL + `/HJYBCFRB/${this.$version}/stock-count/`,
                        headers:{
                            Authorization: JSON.parse(localStorage.getItem('auth_token'))
                        },  
                        data: this.$removeNullFields(data)
                    }).then(()=>{                    
                        this.updating_stock = false

                        //update selected product
                        this.product.counted = true                     
                        this.product.stock = data.new_count  
                        
                        //update product list
                        this.products[this.product_index].counted = true
                        this.products[this.product_index].stock = data.new_count
                        localStorage.setItem('stock_take_products',JSON.stringify(this.products))                        
                        localStorage.setItem('last_stock_count',this.$moment().format('YYYY-MM-DD'))

                        //destroy stock state to get new
                        this.destroy = true
                    }).catch((err)=>{
                        this.updating_stock = false
                        alert(err)                    
                    })
                },
            }
        }
        </script>
        <style>
            /* Chrome, Safari, Edge, Opera */
            input::-webkit-outer-spin-button,
            input::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
            }

            /* Firefox */
            input[type=number] {
                -moz-appearance: textfield;
            }
    </style>